import { useCallback, useState } from 'react';
import { FORM_STATUS, useFormStatus } from '../../contexts/form-status-provider';
import { useSignatureValue } from './use-signature-value';
import { SignatureFormat, SignatureMode, SignatureView } from './signature-types';
export const useSignatureField = _ref => {
  let {
    target,
    value,
    onChange
  } = _ref;
  const {
    handleChange,
    cancelUpload,
    signature,
    decodedValue
  } = useSignatureValue({
    value,
    onChange,
    target
  });
  const [signatureMode, setSignatureMode] = useState(() => {
    if (signature == null) {
      return SignatureMode.DRAW;
    }
    switch (decodedValue == null ? void 0 : decodedValue.mimeType) {
      case SignatureFormat.POINTS:
        return SignatureMode.DRAW;
      case SignatureFormat.TEXT:
        return SignatureMode.TYPE;
      default:
        return SignatureMode.UPLOAD;
    }
  });
  const {
    setFormStatus
  } = useFormStatus();
  const handleBeforeChange = useCallback(() => {
    cancelUpload();
    setFormStatus(target, FORM_STATUS.BUSY);
  }, [cancelUpload, setFormStatus, target]);
  const handleClear = useCallback(() => {
    cancelUpload();
    handleChange(null);
    setFormStatus(target, FORM_STATUS.READY);
  }, [cancelUpload, handleChange, setFormStatus, target]);
  const clearable = signature != null;
  const signatureValueForView = undefinedIfUnsupportedByCurrentMode(signatureMode, signature, decodedValue);
  const signatureView = (() => {
    switch (signatureMode) {
      case SignatureMode.DRAW:
        return SignatureView.DRAW;
      case SignatureMode.TYPE:
        return SignatureView.TYPE;
      case SignatureMode.UPLOAD:
        return signatureValueForView != null ? SignatureView.IMAGE : SignatureView.UPLOAD;
      default:
        return SignatureView.DRAW;
    }
  })();
  return {
    signature,
    decodedValue,
    signatureMode,
    clearable,
    signatureValueForView,
    signatureView,
    handleChange,
    setSignatureMode,
    handleBeforeChange,
    handleClear
  };
};
const ACCEPTED_FORMATS_BY_MODE = {
  [SignatureMode.DRAW]: decodedValue => (decodedValue == null ? void 0 : decodedValue.mimeType) === SignatureFormat.POINTS,
  [SignatureMode.TYPE]: decodedValue => (decodedValue == null ? void 0 : decodedValue.mimeType) === SignatureFormat.TEXT,
  [SignatureMode.UPLOAD]: decodedValue => (decodedValue == null ? void 0 : decodedValue.mimeType) !== SignatureFormat.POINTS && (decodedValue == null ? void 0 : decodedValue.mimeType) !== SignatureFormat.TEXT
};
function undefinedIfUnsupportedByCurrentMode(mode, signature, decodedValue) {
  if (!signature) {
    return undefined;
  }
  const isAcceptedFormat = ACCEPTED_FORMATS_BY_MODE[mode](decodedValue);
  return isAcceptedFormat ? signature : undefined;
}
//# sourceMappingURL=use-signature-field.js.map